import { mergeAttributes, Node } from "@tiptap/core";

export default Node.create({
  name: "queryTextBox",

  group: "block",

  content: "inline*",

  addAttributes() {
    return {
      qid: {
        default: "",
      },
      text: {
        default: "",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "query-text-box",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["query-text-box", mergeAttributes(HTMLAttributes), 0];
  },

  addNodeView() {
    return ({ node }) => {
      let { text } = node.attrs;
      if (!text) {
        const firstNode = node.content.firstChild;
        if (firstNode?.text) {
          text = firstNode.text;
        }
      }
      const parentDiv = document.createElement("div");
      const div = document.createElement("div");

      const style = {
        fontSize: "12px",
        fontStyle: "italic",
        color: "#6b7280",
        padding: "3px 10px 3px 10px",
        backgroundColor: "#eee",
        borderLeft: "5px solid #ccc",
        cursor: "pointer",
        width: "fit-content",
      };
      Object.assign(div.style, style);
      // on click, text is copied to clipboard
      parentDiv.addEventListener("click", () => {
        navigator.clipboard.writeText(text);
        (window as Window).openFpToast("Query copied to clipboard", "success");
      });

      div.innerHTML = text;
      parentDiv.appendChild(div);

      return {
        dom: parentDiv,
      };
    };
  },

  addKeyboardShortcuts() {
    return {
      "Mod-Backspace": () => this.editor.commands.deleteNode(this.name),
    };
  },
});
